import { useMemo } from "react";
import { useNavigate } from "react-router";

import { Plus } from "components/icons/generated";

import { CommandPaletteActionType, CommandPaletteBucket } from "../types";
import { BUCKET_IDS } from "../constants";

const useCommandPaletteCreateBucket = (): CommandPaletteBucket => {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      id: BUCKET_IDS.CREATE,
      title: "Create",
      keywords: ["new", "add", "create"],
      order: 1,
      getActions: () => [
        {
          type: CommandPaletteActionType.SIMPLE,
          id: "create-stack",
          title: "Create new stack",
          bucketId: BUCKET_IDS.CREATE,
          icon: Plus,
          onAction: () => navigate("/new/stack"),
        },
        {
          type: CommandPaletteActionType.SIMPLE,
          id: "create-module",
          title: "Create new module",
          bucketId: BUCKET_IDS.CREATE,
          icon: Plus,
          onAction: () => navigate("/new/module"),
        },
        {
          type: CommandPaletteActionType.SIMPLE,
          id: "create-context",
          title: "Create new context",
          bucketId: BUCKET_IDS.CREATE,
          icon: Plus,
          onAction: () => navigate("/new/context"),
        },
      ],
    }),
    [navigate]
  );
};

export default useCommandPaletteCreateBucket;
